// extracted by mini-css-extract-plugin
export default {"captionEmphasis":"_2Mwdva0gwFjwiVCDzK_C97"};